import { Dropdown } from "react-bootstrap";
import { Menu } from "@headlessui/react";
import trash from "../../assets/trash.png";
import { itemsGroupService } from "../../services/itemGroup.service";
import LogicContext from "../../Context/LogicContext";
import { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
// import '../pages/ItemPage.css'
import {
  SetTGroupItemList,
  GetGroupItemList,
  SetGroupBackup,
  GetGroupBackup,
  ResetGroupEdit,
  SetProductFeature,
  GetProductFeature,
} from "../../store/itemGroupAtom";
import underscore from "underscore";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { useLocation, useNavigate, Link } from "react-router-dom";

const columns = [
  {
    title: "Id",
    key: "Item_Group_Id",
    dataIndex: "Item_Group_Id",
    sorter: (a, b) => (a?.Item_Group_Id ?? "") - (b?.Item_Group_Id ?? ""),

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: "Group Name",
    key: "Item_Group_Name",
    dataIndex: "Item_Group_Name",
    className: "text-primary",
    sorter: (a, b) =>
      (a?.Item_Group_Name ?? "").localeCompare(b?.Item_Group_Name ?? ""),
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: "Feature Name",
    dataIndex: "Product_Feature_Name",
    className: "text-Product_Feature_Name",
    sorter: (a, b) =>
      (a?.Product_Feature_Name ?? "").localeCompare(
        b?.Product_Feature_Name ?? ""
      ),

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: "Type",
    dataIndex: "Item_Group_Type_Name",
    // sorter: (a, b) => a.Item_Group_Type_Name.localeCompare(b.Item_Group_Type_Name)
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: "Status",
    dataIndex: "Item_Group_Status_Name",
    sorter: (a, b) =>
      (a?.Item_Group_Status_Name ?? "").localeCompare(
        b?.Item_Group_Status_Name ?? ""
      ),
    render: (record) => (
      <span
        className={`${
          record === "Active"
            ? "text-green-500"
            : record === "Inactive"
            ? "text-red-500"
            : ""
        }`}
      >
        {record}
      </span>
    ),
  },
];

function ItemGroupPage() {
  const logicContext = useContext(LogicContext);
  const setItemGroupList = SetTGroupItemList();
  const setProductFeature = SetProductFeature();
  const setGroupBackUp = SetGroupBackup();
  const itemGroupBackup = GetGroupBackup();
  const groupList = GetGroupItemList();
  const resetItemToEdit = ResetGroupEdit();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const [itemSelect, setItemSelect] = useState([]);

  useEffect(() => {
    if (groupList?.length < 1) {
      itemsGroupService.getGroupItemsList().then((res) => {
        if (res.data) {
          setItemGroupList(res?.data?.group_info);
          setProductFeature(res?.data?.product_feature_info);
          setGroupBackUp(res?.data?.group_info);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupList]);

  function loadItemsFromServer() {
    itemsGroupService.getGroupItemsList().then((res) => {
      if (res.data) {
        setItemGroupList(res?.data?.group_info);
        setProductFeature(res?.data?.product_feature_info);
        setGroupBackUp(res?.data?.group_info);
      }
    });
  }

  function customFilter(value) {
    if (value === "All") return setItemGroupList(itemGroupBackup);

    if (value === "Item_Id") {
      var temp = underscore.sortBy(groupList, value);
      var temp2 = temp.reverse();
      setItemGroupList(temp2);
    } else {
      var customFilter = underscore.sortBy(groupList, value);
      setItemGroupList(customFilter);
    }
  }

  function customFilterByStatus(status) {
    var customFilter = itemGroupBackup.filter(
      (item) => item.Item_Group_Status_Name === status
    );
    setItemGroupList(customFilter);
  }

  function filterItemReturnable(val) {
    var customFilter = itemGroupBackup.filter(
      (item) => item.Item_Group_Returnable_Name === val
    );
    setItemGroupList(customFilter);
  }

  function filterIventoryItems(status) {
    // var customFilter = itemMasterList.filter(
    //   (item) => item.Item_Tracking_Need_Name === status
    // );
    // setItemListState(customFilter);
  }

  function selectedItems(itemList) {
    setItemSelect(itemList);
  }

  function setItemToActive() {
    var xmlString = "";
    itemSelect?.map((item) => {
      xmlString += `<a><refno>${item.Item_Group_Id} </refno></a>`;
    });

    itemsGroupService
      .setGroupItemActive(`<root> ${xmlString} </root>`)
      .then((res) => {
        logicContext.showToast(res.data[0]["message_text"], "success");
        loadItemsFromServer();
      })
      .catch((err) => console.log("err ", err));
  }

  function setItemToInActive() {
    var xmlString = "";
    itemSelect?.map((item) => {
      xmlString += `<a><refno>${item.Item_Group_Id} </refno></a>`;
    });

    itemsGroupService
      .setGroupItemInActive(`<root> ${xmlString} </root>`)
      .then((res) => {
        logicContext.showToast(res.data[0]["message_text"], "success");
        loadItemsFromServer();
      })
      .catch((err) => console.log("err ", err));
  }

  function deleteItems() {
    var xmlString = "";
    itemSelect?.map((item) => {
      xmlString += `<a><refno>${item.Item_Id} </refno></a>`;
    });

    itemsGroupService
      .deleteItems(`<root> ${xmlString} </root>`)
      .then((res) => {
        console.log("Del ", res.data);
        loadItemsFromServer();
      })
      .catch((err) => console.log("err ", err));
  }

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: groupList.length,
  };

  function handleRowClick(record) {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/item-group-details/${record?.Item_Group_Id}`
    );
  }

  return (
    <>
      <section className="">
        <section className="flex justify-between ">
          <div className="flex items-center space-x-2">
            <div>
              <Menu as="div" className="relative inline-block text-left">
                <Menu.Button className="inline-flex justify-center items-center bg-gray-200 text-sm text-gray-700 font-medium px-3 py-2 rounded border-[1px] border-gray-200 hover:bg-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500">
                  FILTER BY
                  <svg
                    className="ml-2 h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </Menu.Button>

                <Menu.Items className="absolute z-10 mt-2 w-56 origin-top-left bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none">
                  <div className="p-1">
                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => customFilter("All")}
                          className={`${
                            active ? "bg-gray-100" : ""
                          } w-full text-left px-4 py-2 text-sm text-gray-700`}
                        >
                          All
                        </button>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => customFilterByStatus("Active")}
                          className={`${
                            active ? "bg-gray-100" : ""
                          } w-full text-left px-4 py-2 text-sm text-gray-700`}
                        >
                          Active Items
                        </button>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => customFilterByStatus("Inactive")}
                          className={`${
                            active ? "bg-gray-100" : ""
                          } w-full text-left px-4 py-2 text-sm text-gray-700`}
                        >
                          Inactive Items
                        </button>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => filterIventoryItems("Yes")}
                          className={`${
                            active ? "bg-gray-100" : ""
                          } w-full text-left px-4 py-2 text-sm text-gray-700`}
                        >
                          Inventory Items
                        </button>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => filterIventoryItems("No")}
                          className={`${
                            active ? "bg-gray-100" : ""
                          } w-full text-left px-4 py-2 text-sm text-gray-700`}
                        >
                          Non Inventory Items
                        </button>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => filterItemReturnable("No")}
                          className={`${
                            active ? "bg-gray-100" : ""
                          } w-full text-left px-4 py-2 text-sm text-gray-700`}
                        >
                          Non Returnable Items
                        </button>
                      )}
                    </Menu.Item>

                    <Menu.Item>
                      {({ active }) => (
                        <button
                          onClick={() => filterItemReturnable("Yes")}
                          className={`${
                            active ? "bg-gray-100" : ""
                          } w-full text-left px-4 py-2 text-sm text-gray-700`}
                        >
                          Returnable Items
                        </button>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Menu>
            </div>
            {/* <div className="flex mt-1  rounded bg-filterColor pr-4 -ml-2 ">
                <Dropdown>
                  <Dropdown.Toggle
                    style={{
                      backgroundColor: "#E5E5E5",
                      border: "none",
                      color: "#45444B",
                      fontSize: "12px",
                      height: "35px",
                    }}
                    id="dropdown-basic"
                  >
                    FILTER BY
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => customFilter("All")}>
                      All
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => customFilterByStatus("Active")}
                    >
                      Active Items
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => customFilterByStatus("Inactive")}
                    >
                      InActive Items
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => filterIventoryItems("Yes")}>
                      Inventory Items
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => filterIventoryItems("No")}>
                      Non Inventory Items
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => filterItemReturnable("No")}>
                      Non Returnable Items
                    </Dropdown.Item>

                    <Dropdown.Item onClick={() => filterItemReturnable("Yes")}>
                      Returnable Items
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}

            <Tooltip title="Reload">
              {/* <RestartAlt
                  className=" cursor ml-2 mt-1"
                  onClick={() => loadItemsFromServer()}
                  color="primary"
                  fontSize="large"
                /> */}
              <button
                onClick={() => loadItemsFromServer()}
                className="text-blue-600 hover:text-blue-800 transition-colors p-1.5 rounded-full bg-gray-200 hover:bg-gray-100 active:rotate-12 active:bg-gray-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                  />
                </svg>

                {/* <RestartAltIcon fontSize="medium" /> */}
              </button>
            </Tooltip>
          </div>

          <div className="flex  ">
            {itemSelect.length > 0 ? (
              <div className="flex ">
                <button
                  onClick={() => setItemToActive()}
                  className=" bg-filterColor rounded text-black  text-xs py-[1.8vh] font-[Poppins]  mt-1 mr-1 px-4"
                >
                  ACTIVE
                </button>

                <button
                  onClick={() => setItemToInActive()}
                  className="bg-filterColor mx-2  rounded text-black text-xs py-[1.8vh] font-[Poppins] mt-1  px-4"
                >
                  INACTIVE
                </button>

                <img
                  onClick={() => deleteItems()}
                  className=" bg-filterColor mr-2   px-4 py-[1.8vh] mt-1   rounded text-black"
                  src={trash}
                  alt=""
                />

                {/* <button className=" bg-filterColor rounded text-black text-sm font-[Poppins] py-2 mt-1  px-3">
                  Import
                </button>

                <button className="bg-filterColor mx-2 rounded text-black text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3">
                  Export
                </button> */}
              </div>
            ) : null}

            <Link
              to={`/${currModuleId}/${currModuleName}/${currUserMenu}/add-item-group`}
            >
              <Tooltip title="Add New">
                <button className="p-2 rounded border border-gray-200 hover:bg-gray-100 transition">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="size-4"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </Tooltip>
            </Link>
          </div>
        </section>

        {/*  Table here... */}
        <div className="mt-4">
          <GeneralCustomTable
            tableHeadList={columns}
            tableDataList={groupList}
            allowCheckBox={true} // show checkBox for each row
            setSelectedRows={selectedItems}
            paginationOptions={paginationOptions}
            rowKey={(record) => record.Item_Group_Id} // custom key
            handleRowClick={handleRowClick}
          />
        </div>
      </section>
    </>
  );
}

export default ItemGroupPage;
